import Directory from "../components/directory";
import Checkbox from "../components/checkbox";
import CmSelect from "../components/select";
import LocationFilter from "../components/location-filter";

import elasticSearch from "../lib/elastic-search";
import { getURLParams } from "../lib/url";

import isPlainObject from "lodash/isPlainObject"
import isArray from "lodash/isArray"
import isEqual from "lodash/isEqual"
import debounce from "lodash/debounce"

export default {
  components: {
    Directory,
    Checkbox,
    CmSelect,
    LocationFilter
  },

  props: {
    filters: {
      type: Array
    }
  },

  data() {
    return {
      isLoading: true,
      isUpdatedFromUrl: false,

      page: 0,
      size: 24,

      response: null,

      debouncedUpdateUrl: debounce(this.updateUrl, 1000, {
        leading: true,
        trailing: true
      })
    };
  },

  created() {
    this.fetchResults()
      .then(response => {
        this.response = response;
      })
      .catch(error => {
        console.error(error);
      })
      .then(() => {
        this.isLoading = false;
      });

    window.addEventListener("popstate", this.setFilterValuesFromLocation);
  },

  computed: {
    resultCount() {
      if (this.response) {
        return this.response.hits.total;
      } else {
        return 0;
      }
    },

    isInitialLoad() {
      return this.isLoading && !this.response;
    }
  },

  watch: {
    query() {
      this.page = 0;
      this.fetchResults()
        .then(response => {
          this.response = response;
        })
        .catch(error => {
          console.error(error);
        })
        .then(() => {
          this.isLoading = false;
        });
    },

    filterValues: {
      handler(next, prev) {
        if (this.isUpdatedFromUrl) {
          this.isUpdatedFromUrl = false;
        } else {
          this.debouncedUpdateUrl(next);
        }
      },
      deep: true
    }
  },

  methods: {
    setFilterValuesFromLocation() {
      this.isUpdatedFromUrl = true;

      this.filterValues = this.generateFilterValues(this.generateFilters());
    },

    generateDefaultFilterValues(filters) {
      return filters.reduce((obj, filter) => {
        obj[filter.key] = filter.default;
        return obj;
      }, {});
    },

    generateFilterValues(filters) {
      return filters.reduce((obj, filter) => {
        obj[filter.key] = filter.initial || filter.default;
        return obj;
      }, {});
    },

    fetchResults(page = 0) {
      this.isLoading = true;

      const promise = elasticSearch({
        index: this.index,
        size: this.size,
        from: this.size * page,
        body: this.query
      });

      return promise;
    },

    fetchNextPage() {
      this.fetchResults(this.page + 1)
        .then(response => {
          this.response.hits.hits.push(...response.hits.hits);

          this.page++;
        })
        .catch(error => {
          console.error(error);
        })
        .then(() => {
          this.isLoading = false;
        });
    },

    clearAllFilters() {
      this.clearFilter(this.filterKeys);
    },

    clearFilter(keys, value) {
      keys.forEach(key => {
        if (value) {
          this.filterValues[key] = this.filterValues[key].filter(
            el => el !== value
          );
        } else {
          this.filterValues[key] = this.defaultValues[key];
        }
      });
    },

    updateUrl(filterValues) {
      let url = new URL(window.location);

      this.filterArray.forEach(el => {
        const value = filterValues[el.key];
        const key = el.urlKey || el.key;

        if (!isEqual(value, el.default)) {
          if (isArray(value)) {
            url.searchParams.delete(key);
            value.forEach(v => {
              url.searchParams.append(key, v);
            });
          } else if (isPlainObject(value)) {
            url.searchParams.set(key, JSON.stringify(value));
          } else {
            url.searchParams.set(key, value);
          }
        } else {
          url.searchParams.delete(key);
        }
      });

      window.history.pushState(null, null, url.href);
      const { search } = window.location;
      const urlParams = new URLSearchParams(search);

      let googleEventString = "";

      Array.from(urlParams.keys()).map(key => {
        const param = urlParams.get(key);
        if (param.length > 1) {
          key = key.replace(/_/g, " ");
          googleEventString += key + ": " + param + ", ";
        }
      });

      const eventName = this.unitLabels.singular.toLowerCase();
      window.trackGoogleEvent('search', eventName, googleEventString);
    }
  }
};



// WEBPACK FOOTER //
// ./app/javascript/mixins/directory.js